import * as React from 'react';
import { MediaQuery, Util } from '@grandvisionhq/common';
import { ResponsiveImage, Heading } from '@grandvisionhq/elements';
import BlogMeta from '../BlogMeta/BlogMeta.js';

const BlogCard = ({ image , mobileImage , title , locale , readingTime , publishDate , summary , url , minutesLabel  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const imageUrl = isSmallScreen && mobileImage ? mobileImage.url : image === null || image === void 0 ? void 0 : image.url;
    if (!imageUrl && !title && !summary) {
        console.error('BlogCard: missing content, please supply an image, mobileImage, title or summary');
        return null;
    }
    const defaultImgSizes = {
        M: 768,
        L: 512,
        XL: 720,
        MAX: 960
    };
    const defaultParams = {
        fit: 'fillmax'
    };
    const extraPixelDensities = [
        2
    ];
    const srcSet = Util.createImageSrcSet(imageUrl !== null && imageUrl !== void 0 ? imageUrl : '', defaultImgSizes, defaultParams, {
        extraPixelDensities
    });
    const sizes = Util.createImageSizes(defaultImgSizes, imageUrl !== null && imageUrl !== void 0 ? imageUrl : '', {
        extraPixelDensities
    });
    var _alt;
    return /*#__PURE__*/ React.createElement("a", {
        className: "blog-card",
        href: url
    }, /*#__PURE__*/ React.createElement("div", {
        className: "blog-card__content"
    }, image && imageUrl && /*#__PURE__*/ React.createElement(ResponsiveImage, {
        className: "blog-card__image",
        src: imageUrl,
        srcSet: srcSet,
        sizes: sizes,
        alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : ''
    }), /*#__PURE__*/ React.createElement("div", {
        className: "blog-card__text"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "blog-card__title"
    }, Util.truncateString(title, 50)), summary && /*#__PURE__*/ React.createElement("p", {
        className: "blog-card__paragraph"
    }, Util.truncateString(summary, 200)), /*#__PURE__*/ React.createElement(BlogMeta, {
        publishDate: publishDate,
        readingTime: readingTime,
        minutesLabel: minutesLabel,
        locale: locale
    }))));
};
var BlogCard$1 = /*#__PURE__*/ React.memo(BlogCard);

export { BlogCard$1 as default };
//# sourceMappingURL=BlogCard.js.map
